export default {
    name: 'MiniProgress',
    props: {
        target: {
            type: Number,
            default: 0,
        },
        height: {
            type: String,
            default: '10px',
        },
        color: {
            type: String,
            default: '#3da0ff',
        },
        percentage: {
            type: Number,
            default: 0,
        },
    },
};
